import React from 'react';
import { useTheme } from 'styled-components';
import {
  Box,
  InformationLayer,
  InformationLayerTitle,
  Text,
} from '@sparknz/spark-pattern-library';

import { OpeningHour, StoreItemViewModel } from 'shared/types/store';
import { addressLine1, addressLine2 } from 'shared/utils/storeViewModel.utils';
import {
  InStockPill,
  OutStockPill,
  PhoneLink,
  Subtitle,
} from '../../StoreListSection.styles';

interface StoreListInformationLayerProps {
  selectedStore: StoreItemViewModel;
  setOpen: (open: boolean) => void;
  isOpen: boolean;
}

function StoreListInformationLayer({
  setOpen,
  selectedStore,
  isOpen,
}: StoreListInformationLayerProps) {
  const {
    palette: { baseColors },
  } = useTheme();
  if (!selectedStore) return null;
  return (
    <InformationLayer
      isOpen={isOpen}
      onClose={() => {
        setOpen(false);
      }}
    >
      {selectedStore?.stockStatus === 'IN_STOCK' ? (
        <InStockPill mb="s2" variant="footnoteMedium">
          In stock
        </InStockPill>
      ) : (
        <OutStockPill mb="s2" variant="footnoteMedium">
          Out of stock
        </OutStockPill>
      )}
      <InformationLayerTitle>{selectedStore?.storeName}</InformationLayerTitle>
      <Box mb="s3">
        <Subtitle variant="footnoteDemi">Address</Subtitle>
        <Text variant="bodySDemi">
          <span>{addressLine1(selectedStore)}</span>
          <br />
          <span>{addressLine2(selectedStore)}</span>
        </Text>
      </Box>
      <Box mb="s2">
        <Subtitle variant="footnoteDemi">Phone number</Subtitle>
        <PhoneLink href={`tel:${selectedStore?.phoneNumber}`}>
          {selectedStore?.phoneNumber}
        </PhoneLink>
      </Box>
      <Box mb="s4">
        <Subtitle variant="footnoteDemi" mb="s1">
          Opening hours
        </Subtitle>
        {selectedStore?.openingHours.map((openingHour, index) => {
          const typedOpeningHour = openingHour as OpeningHour;
          return (
            <Box
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
              key={typedOpeningHour.day}
              pb="s1"
            >
              <Text
                variant="bodySDemi"
                color={index === 0 && baseColors.mawhero}
              >
                {typedOpeningHour.day}
              </Text>
              <Text
                variant="bodySDemi"
                color={index === 0 && baseColors.mawhero}
              >
                {typedOpeningHour.time}
              </Text>
            </Box>
          );
        })}
      </Box>
      <Subtitle variant="footnoteDemi">
        This product is available for same day pick up. You can collect your
        order up to one hour before the store closes.
      </Subtitle>
    </InformationLayer>
  );
}

export default StoreListInformationLayer;
